<template>
  <v-app style="height: 100%; max-width: 450px; background-color: #EEEEEE;"
    :class="{on_desktop: $vuetify.breakpoint.smAndUp}"
    class="d-flex flex-column align-center"
  >
      <Header />

      <div class="ma-2 px-2 py-4 white rounded d-flex flex-column">
        <div class="px-2">
          <div style="font-size: 24px;">What happens next...</div>
          
          <div class="mt-2" style="font-size: 16px; line-height: 1.6;">
            We will send you notification when a new lead comes in.  Respond
            to customers quickly if you want the best chance of winning jobs. 
          </div>

          <div class="mt-2" style="font-size: 16px; line-height: 1.6;">
            For more tips contact <a :href="mailto">Support</a>.
          </div>
        </div>

        <v-img class="mt-3" src="@/assets/wizard/thumbsup.png" />

      </div>

      <div class="d-flex justify-center py-2 white mt-auto">
        <v-btn color="primary" class="ml-4" :to="{ name: 'home'}">Take me to the App</v-btn>
      </div>
  </v-app>
</template>

<script>
import Header from './Header'

import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'WizardConfirmation',

  components: { Header },

  computed: {
    ...mapGetters('auth', ['me']),

    mailto() {
      return 'mailto:support@referra.pro?subject=' + 
        encodeURIComponent(`Tips for ${ this.me.business_name }(${ this.me.pro_id })`)
    },
  },

  methods: {
    ...mapActions('auth', ['loadMe'])
  },

  created() {
    this.loadMe()
  },
}
</script>